// Portal feature flags.
//
// These are intentionally global (same value in every lane), NOT per-lane
// build config — so a plain compile-time constant is appropriate here and does
// NOT fall under the "never bake lane-specific config into a build" rule. If a
// flag ever needs to differ stage vs prod, move it to the runtime GET /api/config
// surface (see ConfigContext) instead of adding a VITE_* var.

// Card payment is DISABLED for now — quotes are handed out by sales reps and
// Argo isn't taking credit cards through the portal yet. When card processing
// goes live, flip this to `true` (the checkout page, payment-provider
// abstraction, and backend /checkout routes are all left intact). The invoice
// path was removed entirely (an approved quote simply stays a quote; AR invoices
// after printing in the ERP), so card is the only settlement action this gates.
export const CARD_PAYMENT_ENABLED = false;
